import { render, staticRenderFns } from "./broker-program.vue?vue&type=template&id=c63d7ad8&"
import script from "./broker-program.vue?vue&type=script&lang=js&"
export * from "./broker-program.vue?vue&type=script&lang=js&"
import style0 from "./broker-program.vue?vue&type=style&index=0&id=c63d7ad8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports